var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGodtvprofile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 473.62,
    height: 473.62,
    viewBox: "0 0 473.62 473.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M236.81,0C106.02,0,0,106.02,0,236.81s106.02,236.81,236.81,236.81,236.81-106.02,236.81-236.81S367.6,0,236.81,0M420.49,360.65c-7.96,11.77-17.02,22.75-27.06,32.8-1.62,1.62-3.27,3.22-4.95,4.79-18.79-83.77-101.93-136.45-185.7-117.67-58.68,13.16-104.51,58.99-117.67,117.67-1.67-1.57-3.32-3.17-4.95-4.79-20.21-20.2-36.33-44.1-47.48-70.41C3.5,254.07,11.19,175.03,53.11,112.98c24.04-35.62,57.9-63.5,97.47-80.27,68.96-29.19,148-21.5,210.05,20.42,35.62,24.04,63.5,57.9,80.27,97.47,29.19,68.96,21.5,148-20.42,210.05",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M236.81,83.3c-48.77,0-88.3,39.53-88.3,88.3s39.53,88.3,88.3,88.3,88.3-39.53,88.3-88.3h0c0-48.77-39.53-88.3-88.3-88.3",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGodtvprofile);
export default __webpack_public_path__ + "static/media/godtvprofile.93a6692d6429efea17545954aa3e0493.svg";
export { ForwardRef as ReactComponent };